import PropTypes from "prop-types"

// @mui material components
import Icon from "@mui/material/Icon"
import Swal from "sweetalert2"
import { showToast } from "utils/swalToast"
// Material Dashboard 2 React components
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import MDButton from "components/MDButton"

import { useEffect } from "react"

import { useMaterialUIController } from "context"

import { useNavigate } from "react-router-dom"
import Chip from "@mui/material/Chip"
import { CircularProgress, Grid, Stack, Tooltip } from "@mui/material"
import {
  checkEnableStatus,
  deleteDevice,
  extractMessage,
  openDoor,
  toggleEnableStatus,
  toggleOnlineStatus,
} from "../../service"
import { useState } from "react"
function Devices({
  identicador,
  name,
  company,
  branch_office,
  branch_code,
  event,
  location,
  location_code,
  type,
  ip,
  nvr,
  estado,
  enable,
  statusCheckVersion,
  noGutter,
  onDelete,
}) {
  const [controller] = useMaterialUIController()
  const { darkMode } = controller
  const navigate = useNavigate()

  useEffect(() => {
    setIsEnable(Boolean(enable))
  }, [enable])

  function handleEdit(id) {
    navigate(`/dispositivos/${id}`)
  }

  const handleDelete = async (id) => {
    Swal.fire({
      title: "¿Está seguro que desea eliminar este dispositivo?",
      text: `IP del equipo: ${ip}. �No podr�s revertir esta acci�n!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setProcessingAction(true)
          const deleteResult = await deleteDevice(id)
          showToast({
            title: extractMessage(deleteResult) || "Dispositivo eliminado exitosamente",
            icon: "success",
          })
          onDelete()
        } catch (error) {
          if (error.status === 404) {
            showToast({ icon: "info", title: "El dispositivo ya había sido eliminado" })
            onDelete()
          } else {
            showToast({ icon: "error", title: "Error", text: error.message })
          }
        } finally {
          setProcessingAction(false)
        }
      }
    })
  }

  const handleEnableDisable = async (id, enableDisable) => {
    Swal.fire({
      title: `¿Está seguro que desea ${!enableDisable ? "desactivar" : "activar"
        } este dispositivo?`,

      text: `IP del equipo: ${ip}. ${!enableDisable ? "Ya no se" : "Se"} recibiran paquetes del mismo.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: `Sí, ${!enableDisable ? "desactivar" : "activar"}`,
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setProcessingAction(true)
          setEnableLoading(true)
          await toggleEnableStatus(id, enableDisable)
          setIsEnable(Boolean(enableDisable))
          showToast({
            title: `Dispositivo ${!enableDisable ? "desactivado" : "activado"} exitosamente`,
            icon: "success",
          })
          onDelete()
        } catch (error) {
          showToast({ icon: "error", title: "Error", text: error.message })
        } finally {
          setEnableLoading(false)
          setProcessingAction(false)
        }
      }
    })
  }
  const [isOnline, setIsOnline] = useState(Boolean(estado))
  const [isEnable, setIsEnable] = useState(Boolean(enable))
  const [onlineLoading, setOnlineLoading] = useState(true)
  // enableLoading solo tiene sentido si el dispositivo aparece como online inicialmente
  const [enableLoading, setEnableLoading] = useState(Boolean(estado))
  const [initialChecksCompleted, setInitialChecksCompleted] = useState(false)
  const [processingAction, setProcessingAction] = useState(false)
  const actionsDisabled = !initialChecksCompleted || processingAction

  useEffect(() => {
    let isMounted = true

    const checkInitialOnlineStatus = async () => {
      setOnlineLoading(true)
      try {
        const data = await toggleOnlineStatus(identicador)
        const online = Boolean(data?.online)
        if (isMounted) {
          setIsOnline(online)
        }
        return online
      } catch (error) {
        if (isMounted) {
          setIsOnline(false)
        }
        return false
      } finally {
        if (isMounted) {
          setOnlineLoading(false)
        }
      }
    }

    const checkInitialEnableStatus = async () => {
      setEnableLoading(true)
      try {
        const data = await checkEnableStatus(identicador)
        if (isMounted) {
          setIsEnable(Boolean(data?.enable))
        }
      } catch (error) {
        if (isMounted) {
          setIsEnable(false)
        }
      } finally {
        if (isMounted) {
          setEnableLoading(false)
        }
      }
    }

    const runInitialChecks = async () => {
      setInitialChecksCompleted(false)
      const online = await checkInitialOnlineStatus()
      if (online) {
        await checkInitialEnableStatus()
      } else if (isMounted) {
        setIsEnable(false)
        setEnableLoading(false)
      }
      if (isMounted) {
        setInitialChecksCompleted(true)
      }
    }

    runInitialChecks()

    return () => {
      isMounted = false
    }
  }, [identicador, statusCheckVersion])

  const handleOpenDoor = async (id) => {
    Swal.fire({
      title: "¿Está seguro que desea abrir la puerta?",
      text: `Se enviará la señal de apertura al dispositivo ${name}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sí, abrir",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setProcessingAction(true)
          await openDoor(id)
          showToast({ title: "Apertura enviada con exito", icon: "success" })
        } catch (error) {
          showToast({ icon: "error", title: "Error", text: error.message })
        } finally {
          setProcessingAction(false)
        }
      }
    })
  }

  const handleClick = async (id) => {
    if (onlineLoading) return
    setOnlineLoading(true)
    try {
      const data = await toggleOnlineStatus(id)
      const online = Boolean(data?.online)
      setIsOnline(online)

      if (!online) {
        setIsEnable(false)
        setEnableLoading(false)
        return
      }

      setEnableLoading(true)
      try {
        const enableData = await checkEnableStatus(id)
        setIsEnable(Boolean(enableData?.enable))
      } catch (error) {
        setIsEnable(false)
      } finally {
        setEnableLoading(false)
      }
    } catch (error) {
      showToast({ icon: "error", title: "No se pudo verificar el estado", text: error?.message || "Intenta nuevamente." })
    } finally {
      setOnlineLoading(false)
    }
  }

  return (
    <MDBox
      id={identicador}
      component="li"
      display="flex"
      justifyContent="space-between"
      alignItems="flex-start"
      bgColor={darkMode ? "transparent" : "grey-100"}
      borderRadius="lg"
      p={1}
      mb={noGutter ? 0 : 1}
      mt={0}
    >
      <MDBox width="100%" display="flex" flexDirection="column">
        <Grid container spacing={0} border={1} sx={{ borderColor: darkMode ? "transparent" : "grey.400" }} padding={2} borderRadius={2} mb={0}>
          <Grid item xs={9} md={9}>
            <Stack rowGap={2}>
              <MDTypography variant="h5" fontWeight="light" textTransform="capitalize">
                <b>UBICACIÓN: </b>{company} - {branch_office ? branch_office.toUpperCase() : event?.toUpperCase()}
                {branch_code && <MDTypography variant="caption"> ({branch_code})</MDTypography>}
              </MDTypography>
              <Stack direction="row" alignItems={"center"} justifyContent={"flex-start"} columnGap={2}>
                <MDTypography variant="h6" fontWeight="light" textTransform="capitalize">
                  <b>Nombre:&nbsp;</b>{name}
                </MDTypography>
                <MDTypography variant="caption" fontWeight="light">
                  <b>Zona:</b> <MDTypography variant="caption" fontWeight="light" >{location?.toUpperCase()} {location_code ? `(` + location_code + `)` : ""}</MDTypography>

                </MDTypography>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} md={12}>
            <Grid container spacing={0} border={0.5} sx={{ borderColor: darkMode ? "transparent" : "grey.300" }} padding={2} borderRadius={2} mb={1} mt={2}>
              <Grid item xs={9} md={9}>
                <Stack direction="row" alignItems={"center"} justifyContent={"flex-start"} columnGap={2}>
                  <MDTypography variant="caption" fontWeight="light">
                    <b>TIPO DE EQUIPO: </b>
                    <MDTypography variant="caption" fontWeight="light" textTransform="capitalize">
                      {type.replace('_', ' ')}
                    </MDTypography>
                  </MDTypography>
                  <MDTypography variant="caption" fontWeight="light">
                    <b>TCP/IP: </b><MDTypography variant="caption" fontWeight="light" textTransform="">{ip}
                    </MDTypography>
                  </MDTypography>

                </Stack>
                {type === 'CAMARAS_HIKVISION' && nvr && < MDTypography variant="caption" color="text">
                  Vinculado a:&nbsp;&nbsp;
                  <MDTypography variant="caption" fontWeight="medium" >
                    {nvr?.description} ({nvr?.ip})
                  </MDTypography>&nbsp;&nbsp;ubicado en&nbsp;&nbsp;
                  <MDTypography variant="caption" fontWeight="medium" >
                    {nvr.sucursales?.empresa?.descripcion} - {nvr.sucursales?.descripcion}
                  </MDTypography>
                </MDTypography>}
              </Grid>
              <Grid item xs={3} md={3}>
                <Stack direction="row" alignItems={"center"} justifyContent={"flex-end"} columnGap={2} >
                  <MDTypography variant="caption" color="text">
                    <Tooltip
                      title={
                        isOnline ? "El servidor pudo conectarse al equipo." : "El equipo no esta accesible."
                      }
                    >
                      <span>
                        <Chip
                          clickable
                          onClick={() => handleClick(identicador)}
                          disabled={onlineLoading}
                          variant="outlined"
                          color={isOnline ? "success" : "error"}
                          label={isOnline ? "En linea" : "Desconectado"}
                          icon={
                            onlineLoading ? (
                              <CircularProgress size={16} />
                            ) : (
                              <Icon fontSize="small">{isOnline ? "check_circle" : "cancel"}</Icon>
                            )
                          }
                          sx={{ cursor: onlineLoading ? "not-allowed" : "pointer" }}
                        />
                      </span>
                    </Tooltip>
                  </MDTypography>{" "}
                  {isOnline && <MDTypography variant="caption" color="text">
                    <Tooltip
                      title={
                        isEnable
                          ? "El equipo esta configurado para enviar paquetes a este servidor."
                          : "El equipo no esta configurado para enviar paquetes a este servidor. Debe activarlo."
                      }
                    >
                      <span>
                        <Chip
                          disabled={enableLoading}
                          variant="outlined"
                          color={isEnable ? "success" : "error"}
                          label={isEnable ? "Activo" : "Inactivo"}
                          icon={
                            enableLoading ? (
                              <CircularProgress size={16} />
                            ) : (
                              <Icon fontSize="small">{isEnable ? "check_circle" : "cancel"}</Icon>
                            )
                          }
                        />
                      </span>
                    </Tooltip>
                  </MDTypography>}
                </Stack>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={12}>
            <Stack direction="row-reverse" alignItems={"center"} justifyContent={"flex-start"} columnGap={0}>
              <Tooltip title="Elimina el dispositivo del sistema, no implica que deje de enviar paquetes.">
                <span>
                  <MDButton
                    variant="text"
                    color="error"
                    disabled={actionsDisabled}
                    onClick={() => handleDelete(identicador)}
                  >
                    <Icon>delete</Icon>&nbsp;Eliminar
                  </MDButton>
                </span>
              </Tooltip>
              {isEnable && <Tooltip title="Desactivar el envio de paquetes a este servidor.">
                <span>
                  <MDButton
                    variant="text"
                    color="warning"
                    disabled={actionsDisabled}
                    onClick={() => handleEnableDisable(identicador, false)}
                  >
                    <Icon>power_settings</Icon>&nbsp;Desactivar
                  </MDButton>
                </span>
              </Tooltip>}
              {!isEnable && isOnline && <Tooltip title="Configurar el equipo para enviar paquetes a este servidor.">
                <span>
                  <MDButton
                    variant="text"
                    color="success"
                    disabled={actionsDisabled}
                    onClick={() => handleEnableDisable(identicador, true)}
                  >
                    <Icon>power_settings</Icon>&nbsp;Activar
                  </MDButton>
                </span>
              </Tooltip>}
              {type === "PORTAL_ACCESO" && isOnline && (
                <Tooltip title="Enviar señal de apertura al portal de acceso.">
                  <span>
                    <MDButton
                      variant="text"
                      color="info"
                      disabled={actionsDisabled}
                      onClick={() => handleOpenDoor(identicador)}
                    >
                      <Icon>lock_open</Icon>&nbsp;Abrir
                    </MDButton>
                  </span>
                </Tooltip>
              )}
              <Tooltip title="Modificar los datos del dispositivo">
                <span>
                  <MDButton
                    data-id={identicador}
                    variant="text"
                    color={darkMode ? "white" : "dark"}
                    disabled={actionsDisabled}
                    onClick={() => handleEdit(identicador)}
                  >
                    <Icon>edit</Icon>&nbsp;editar
                  </MDButton>
                </span>
              </Tooltip>
            </Stack>
          </Grid>
        </Grid>
      </MDBox>
    </MDBox >
  )
}

// Setting default values for the props of Bill
Devices.defaultProps = {
  noGutter: false,
  onDelete: () => { },
}

// Typechecking props for the Bill
Devices.propTypes = {
  identicador: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  company: PropTypes.string.isRequired,
  branch_office: PropTypes.string,
  event: PropTypes.string,
  location: PropTypes.string.isRequired,
  type: PropTypes.string,
  ip: PropTypes.string.isRequired,
  serie: PropTypes.string,
  enable: PropTypes.bool.isRequired,
  estado: PropTypes.bool.isRequired,
  statusCheckVersion: PropTypes.number.isRequired,
  noGutter: PropTypes.bool,
  onDelete: PropTypes.func,
}

export default Devices

